import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '.';
import { CustomThemeInterface } from '../interface/custom-theme';

export interface CustomThemeSliceInterface {
  customTheme: CustomThemeInterface;
}

const initialState: CustomThemeSliceInterface = {
  customTheme: {
    rectangle: { borderRadius: 8, borderWidth: 1, borderWidthEnable: 2 },
    logo: {},
  },
};

export const CustomThemeSlice = createSlice({
  name: 'customTheme',
  initialState,
  reducers: {
    setCustomTheme: (state, action: PayloadAction<CustomThemeInterface>) => {
      state.customTheme = action.payload;
    },
    reset: () => initialState,
  },
});

export const { setCustomTheme, reset } = CustomThemeSlice.actions;

// eslint-disable-next-line import/no-default-export
export default CustomThemeSlice.reducer;
